import {ChangeDetectorRef, Component} from "@angular/core";
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../../dip/dip-column";
import {OrganizationUserGroupService} from "../../../services/organization-user-group.service";
import {HttpExtraParams} from "prod-shared";
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {CompanyGroupForm} from "./company-group-form/company-group-form";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../../dip/role";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company-group',
  templateUrl: './company-group.component.html'
})
export class CompanyGroupComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('company.groups.grid_title');
  prodGridToolbarButtonsStatus = {
    isAddButtonDisabled: {
      role: [Role.ROLE_ORGANIZATION_USER_GROUP_EDIT],
      disabled: !this.roleService.hasRole([Role.ROLE_ORGANIZATION_USER_GROUP_EDIT])
    },
    isEditButtonShown: {
      role: [Role.ROLE_ORGANIZATION_USER_GROUP_EDIT],
      disabled: !this.roleService.hasRole([Role.ROLE_ORGANIZATION_USER_GROUP_EDIT])
    },
    isRemoveButtonDisabled: {
      role: [Role.ROLE_ORGANIZATION_USER_GROUP_DELETE],
      disabled: !this.roleService.hasRole([Role.ROLE_ORGANIZATION_USER_GROUP_DELETE])
    }
  };

  override prodGridForm = {
    component: CompanyGroupForm,
    style: {height: '55%', width: '75%'},
    editStyle: {height: '55%', width: '75%'}
  };
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'userGroup.name', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'userGroup.description', type: ProdGridColumnType.STRING}),
    DipColumn.get({
      property: 'permissions',
      type: ProdGridColumnType.STRING,
      transform: {
        transform: ProdGridColumnTransforms.ARRAY_JOIN,
        option: 'name'
      },
      sortable: false
    }),
    DipColumn.get({
      property: 'userGroup.users',
      type: ProdGridColumnType.STRING,
      transform: {transform: ProdGridColumnTransforms.ARRAY_JOIN, option: 'username'},
      sortable: false
    })
  ];

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    override prodGridDataService: OrganizationUserGroupService,
    private roleService: RoleService,
    private organizationTreeSelect: OrganizationTreeSelect,
    private translate: TranslateService) {
      super(changeDetectorRef);
      organizationTreeSelect.gridComponent = this;
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService)));
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }
}
